import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
// ❗️ ИЗМЕНЕНИЕ: Убрали 'Link'
// import { Link } from 'react-router-dom'; 
import { LuWallet, LuPencil, LuBan, LuShieldCheck, LuTrash2 } from 'react-icons/lu';

function AdminUsersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [balanceModal, setBalanceModal] = useState({ open: false, user: null });
  const [balanceForm, setBalanceForm] = useState({ action: 'add', amount: '', description: '' });
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [editModal, setEditModal] = useState({ open: false, user: null, activeTab: 'password' });
  const [passwordForm, setPasswordForm] = useState({ new_password: '', confirm_password: '' });
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [referralForm, setReferralForm] = useState({ referral_percent: '' });
  const [referralLoading, setReferralLoading] = useState(false);
  const [tariffs, setTariffs] = useState([]);
  const [tariffsLoading, setTariffsLoading] = useState(false);
  const [userForm, setUserForm] = useState({ 
    tariff_id: '', 
    trial_days: '', 
    hwid_device_limit: '' 
  });
  const [userFormLoading, setUserFormLoading] = useState(false);
  const [blockModal, setBlockModal] = useState({ open: false, user: null });
  const [blockReason, setBlockReason] = useState('');
  const [blockLoading, setBlockLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { token } = useAuth(); 

  // Загрузка тарифов
  useEffect(() => {
    const fetchTariffs = async () => {
      setTariffsLoading(true);
      try {
        const response = await fetch('/api/admin/tariffs', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setTariffs(data);
        }
      } catch (e) {
        console.error('Ошибка загрузки тарифов:', e);
      } finally {
        setTariffsLoading(false);
      }
    };
    
    if (token) {
      fetchTariffs();
    }
  }, [token]);

  // ❗️ ИЗМЕНЕНИЕ: fetchUsers теперь ВНУТРИ useEffect
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch('/api/admin/users', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) {
          const data = await response.json();
          throw new Error(data.message || 'Не удалось получить список');
        }
        const data = await response.json();
        setUsers(data); 
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
        fetchUsers();
    }
  }, [token]); // ❗️ Теперь массив зависимостей правильный

  // --- Функция удаления ---
  const handleDeleteUser = async (userId, userEmail) => {
    if (!window.confirm(`Вы уверены, что хотите удалить ${userEmail}?`)) {
      return;
    }
    try {
      const response = await fetch(`/api/admin/users/${userId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json(); 
      if (!response.ok) {
        throw new Error(data.message || 'Ошибка удаления');
      }
      // ❗️ ИЗМЕНЕНИЕ: Обновляем список вручную
      setUsers(prevUsers => prevUsers.filter(user => user.id !== userId));
      alert(data.message); 
    } catch (e) {
      alert(`Ошибка: ${e.message}`);
    }
  };

  // --- Функция открытия модального окна баланса ---
  const handleOpenBalanceModal = (user) => {
    setBalanceModal({ open: true, user });
    setBalanceForm({ action: 'add', amount: '', description: '' });
  };

  // --- Функция закрытия модального окна баланса ---
  const handleCloseBalanceModal = () => {
    setBalanceModal({ open: false, user: null });
    setBalanceForm({ action: 'add', amount: '', description: '' });
  };

  // --- Функция открытия модального окна редактирования ---
  const handleOpenEditModal = (user) => {
    setReferralForm({ referral_percent: user.referral_percent ?? '' });
    setEditModal({ open: true, user, activeTab: 'password' });
    setPasswordForm({ new_password: '', confirm_password: '' });
    setUserForm({ tariff_id: '', trial_days: '', hwid_device_limit: '' });
  };

  // --- Функция закрытия модального окна редактирования ---
  const handleCloseEditModal = () => {
    setEditModal({ open: false, user: null, activeTab: 'password' });
    setPasswordForm({ new_password: '', confirm_password: '' });
    setUserForm({ tariff_id: '', trial_days: '', hwid_device_limit: '' });
  };

  // --- Функция открытия модального окна блокировки ---
  const handleOpenBlockModal = (user) => {
    setBlockModal({ open: true, user });
    setBlockReason(user.block_reason || '');
  };

  // --- Функция закрытия модального окна блокировки ---
  const handleCloseBlockModal = () => {
    setBlockModal({ open: false, user: null });
    setBlockReason('');
  };

  // --- Функция блокировки пользователя ---
  const handleBlockUser = async (e) => {
    e.preventDefault();
    if (!blockModal.user) return;

    setBlockLoading(true);
    try {
      const response = await fetch(`/api/admin/users/${blockModal.user.id}/block`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          block_reason: blockReason
        })
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Ошибка блокировки пользователя');
      }

      alert(`Пользователь ${blockModal.user.email} заблокирован`);
      handleCloseBlockModal();
      
      // Обновляем список пользователей
      const usersResponse = await fetch('/api/admin/users', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (usersResponse.ok) {
        const usersData = await usersResponse.json();
        setUsers(usersData);
      }
    } catch (e) {
      alert(`Ошибка: ${e.message}`);
    } finally {
      setBlockLoading(false);
    }
  };

  // --- Функция разблокировки пользователя ---
  const handleUnblockUser = async (userId, userEmail) => {
    if (!window.confirm(`Вы уверены, что хотите разблокировать ${userEmail}?`)) {
      return;
    }
    
    try {
      const response = await fetch(`/api/admin/users/${userId}/unblock`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Ошибка разблокировки пользователя');
      }

      alert(`Пользователь ${userEmail} разблокирован`);
      
      // Обновляем список пользователей
      const usersResponse = await fetch('/api/admin/users', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (usersResponse.ok) {
        const usersData = await usersResponse.json();
        setUsers(usersData);
      }
    } catch (e) {
      alert(`Ошибка: ${e.message}`);
    }
  };

  // --- Функция обновления пользователя (тариф, триал, лимит устройств) ---
  const handleUpdateUser = async (e) => {
    e.preventDefault();
    if (!editModal.user) return;

    // Проверяем, что заполнено хотя бы одно поле
    if (!userForm.tariff_id && !userForm.trial_days && userForm.hwid_device_limit === '') {
      alert('Заполните хотя бы одно поле: тариф, триал или лимит устройств');
      return;
    }

    if (userForm.tariff_id && userForm.trial_days) {
      alert('Выберите либо тариф, либо триал, но не оба одновременно');
      return;
    }

    setUserFormLoading(true);
    try {
      // Определяем action и формируем payload
      let payload = {};
      
      if (userForm.tariff_id) {
        // Выдача тарифа
        payload = {
          action: 'grant_tariff',
          tariff_id: parseInt(userForm.tariff_id, 10)
        };
      } else if (userForm.trial_days) {
        // Выдача триала
        payload = {
          action: 'grant_trial',
          days: parseInt(userForm.trial_days, 10)
        };
      } else if (userForm.hwid_device_limit !== '') {
        // Установка лимита устройств
        payload = {
          action: 'set_device_limit',
          device_limit: userForm.hwid_device_limit === '' || userForm.hwid_device_limit === '0' 
            ? 0 
            : parseInt(userForm.hwid_device_limit, 10)
        };
      } else {
        alert('Заполните хотя бы одно поле: тариф, триал или лимит устройств');
        setUserFormLoading(false);
        return;
      }

      const response = await fetch(`/api/admin/users/${editModal.user.id}/update`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Ошибка обновления пользователя');
      }

      alert(`Пользователь ${data.user_email || editModal.user.email} успешно обновлен!`);
      handleCloseEditModal();
      // Обновляем список пользователей
      const usersResponse = await fetch('/api/admin/users', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (usersResponse.ok) {
        const usersData = await usersResponse.json();
        setUsers(usersData);
      }
    } catch (e) {
      alert(`Ошибка: ${e.message}`);
    } finally {
      setUserFormLoading(false);
    }
  };

  // --- Функция изменения пароля ---
  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!editModal.user) return;

    if (!passwordForm.new_password || passwordForm.new_password.length < 6) {
      alert('Пароль должен содержать минимум 6 символов');
      return;
    }

    if (passwordForm.new_password !== passwordForm.confirm_password) {
      alert('Пароли не совпадают');
      return;
    }

    setPasswordLoading(true);
    try {
      const response = await fetch(`/api/admin/users/${editModal.user.id}/change-password`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          new_password: passwordForm.new_password
        })
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Ошибка изменения пароля');
      }

      alert(`Пароль для ${data.user_email} успешно изменен!`);
      setPasswordForm({ new_password: '', confirm_password: '' });
    } catch (e) {
      alert(`Ошибка: ${e.message}`);
    } finally {
      setPasswordLoading(false);
    }
  };

  // --- Функция обновления процента реферала ---
  const handleUpdateReferralPercent = async (e) => {
    e.preventDefault();
    if (!editModal.user) return;

    const raw = (referralForm.referral_percent ?? '').toString().trim();
    const isResetToDefault = raw === '';
    const percent = isResetToDefault ? null : parseFloat(raw);
    if (!isResetToDefault && (isNaN(percent) || percent < 0 || percent > 100)) {
      alert('Процент должен быть числом от 0 до 100, либо оставьте поле пустым для значения по умолчанию');
      return;
    }

    setReferralLoading(true);
    try {
      const response = await fetch(`/api/admin/users/${editModal.user.id}/referral-percent`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          referral_percent: percent
        })
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Ошибка обновления процента реферала');
      }

      if (percent === null) {
        alert('Процент реферала сброшен: будет использоваться процент по умолчанию');
      } else {
        alert(`Процент реферала успешно обновлен: ${percent}%`);
      }
      
      // Обновляем пользователя в списке
      setUsers(prevUsers => prevUsers.map(u => 
        u.id === editModal.user.id 
          ? { ...u, referral_percent: percent }
          : u
      ));
      
      // Обновляем пользователя в модальном окне
      setEditModal({ ...editModal, user: { ...editModal.user, referral_percent: percent } });
    } catch (e) {
      alert(`Ошибка: ${e.message}`);
    } finally {
      setReferralLoading(false);
    }
  };

  // --- Функция изменения баланса ---
  const handleUpdateBalance = async (e) => {
    e.preventDefault();
    if (!balanceModal.user) return;

    const amount = parseFloat(balanceForm.amount);
    if (!amount || amount <= 0) {
      alert('Введите корректную сумму');
      return;
    }

    setBalanceLoading(true);
    try {
      const response = await fetch(`/api/admin/users/${balanceModal.user.id}/balance`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          action: balanceForm.action,
          amount: amount,
          description: balanceForm.description || 'Изменение баланса администратором'
        })
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Ошибка обновления баланса');
      }

      // Обновляем пользователя в списке
      setUsers(prevUsers => prevUsers.map(user => 
        user.id === balanceModal.user.id 
          ? { ...user, balance: data.balance }
          : user
      ));

      alert(`Баланс успешно обновлен!\nПредыдущий баланс: ${data.previous_balance.toFixed(2)}\nНовый баланс: ${data.balance.toFixed(2)}\nИзменение: ${data.change > 0 ? '+' : ''}${data.change.toFixed(2)}`);
      handleCloseBalanceModal();
    } catch (e) {
      alert(`Ошибка: ${e.message}`);
    } finally {
      setBalanceLoading(false);
    }
  };

  // --- Форматирование даты (без изменений) ---
  const formatExpireDate = (dateString) => {
    if (!dateString) return { text: "N/A", isExpired: false };
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return { text: "N/A", isExpired: false };
    const isExpired = date < new Date();
    const formatted = date.toLocaleString('ru-RU', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
    });
    return { text: formatted, isExpired: isExpired };
  };

  // --- Фильтрация пользователей по поисковому запросу ---
  const filteredUsers = users.filter(user => {
    if (!searchQuery.trim()) return true;
    const query = searchQuery.toLowerCase().trim();
    const email = (user.email || '').toLowerCase();
    const telegramUsername = (user.telegram_username || '').toLowerCase();
    const telegramId = (user.telegram_id || '').toLowerCase();
    const referralCode = (user.referral_code || '').toLowerCase();
    
    return email.includes(query) || 
           telegramUsername.includes(query) || 
           telegramId.includes(query) ||
           referralCode.includes(query) ||
           (user.id && user.id.toString().includes(query));
  });

  // --- Рендеринг ---
  return (
    <main className="admin-page-content">
      <section className="admin-users-page">
        <div className="admin-users-page-header">
          <h2 className="admin-users-page-title">👥 Управление пользователями</h2>
          <div className="admin-users-page-toolbar">
            <div className="admin-users-search-wrap">
              <input
                type="text"
                placeholder="Поиск по email, Telegram, ID..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="admin-users-search-input"
                onFocus={(e) => {
                  e.target.style.borderColor = 'var(--accent-blue)';
                  e.target.style.boxShadow = '0 0 0 3px rgba(36, 129, 204, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'var(--glass-border)';
                  e.target.style.boxShadow = 'none';
                }}
              />
              <span style={{
                position: 'absolute',
                left: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                fontSize: '16px',
                pointerEvents: 'none',
                color: 'var(--text-secondary)'
              }}>🔍</span>
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '16px',
                    padding: '4px 6px',
                    color: 'var(--text-secondary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'var(--surface-hover)';
                    e.target.style.color = 'var(--text-primary)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = 'var(--text-secondary)';
                  }}
                  title="Очистить поиск"
                >
                  ✕
                </button>
              )}
            </div>
            {searchQuery && (
              <span className="admin-users-found-badge">
                Найдено: {filteredUsers.length}
              </span>
            )}
          </div>
        </div>
        
        {loading && <div className="loading-mini">Загрузка...</div>}
        {error && <div className="message-error">{error}</div>}
        
        {!loading && !error && (
          <div className="table-wrapper users-page-table-wrapper">
            <table className="users-table users-page-table">
              {/* ... (вся таблица <thead> и <tbody> без изменений) ... */}
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Email</th>
                  <th>Telegram</th>
                  <th>Role</th>
                  <th>Баланс</th>
                  <th>Статус</th>
                  <th>Сквад</th>
                  <th>Подписка до</th>
                  <th>Реф. Код</th>
                  <th>Приглашен</th>
                  <th>Действия</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map(user => {
                  const liveData = user.live_data ? user.live_data.response : null;
                  let statusKey = "N/A", statusLabel = "N/A", expireAt = { text: "N/A", isExpired: false }, squadName = "N/A";
                  
                  // Проверяем, есть ли UUID пользователя
                  const hasUuid = user.remnawave_uuid && user.remnawave_uuid.trim() !== '';
                  
                  const blocked = Boolean(user.is_blocked);
                  if (blocked) {
                    statusKey = "DISABLED";
                    statusLabel = "BLOCKED";
                  } else if (user.fetch_error) { 
                    statusKey = "Ошибка";
                    statusLabel = "Ошибка";
                  } else if (!hasUuid) {
                    // Если нет UUID, пользователь не синхронизирован с RemnaWave
                    statusKey = "NO_UUID";
                    statusLabel = "Нет UUID";
                    expireAt = { text: "Не синхронизирован", isExpired: false };
                    squadName = "Нет";
                  } else if (liveData === null || liveData === undefined) {
                    // Если UUID есть, но данных нет - пользователь не найден в RemnaWave
                    statusKey = "NOT_FOUND";
                    statusLabel = "Не найден";
                    expireAt = { text: "Не найден", isExpired: false };
                    squadName = "Нет";
                  } else if (liveData) {
                    // Определяем статус на основе данных из RemnaWave
                    if (typeof liveData.status === 'string' && liveData.status.trim()) {
                      statusKey = liveData.status.trim().toUpperCase();
                      statusLabel = statusKey;
                    } else if (liveData.expireAt) {
                      const expireDate = new Date(liveData.expireAt);
                      const now = new Date();
                      if (expireDate < now) {
                        statusKey = "EXPIRED";
                        statusLabel = "EXPIRED";
                      } else if (liveData.activeInternalSquads && liveData.activeInternalSquads.length > 0) {
                        statusKey = "ACTIVE";
                        statusLabel = "ACTIVE";
                      } else {
                        statusKey = "DISABLED";
                        statusLabel = "DISABLED";
                      }
                    } else {
                      statusKey = "DISABLED";
                      statusLabel = "DISABLED";
                    }
                    expireAt = formatExpireDate(liveData.expireAt);
                    const squads = Array.isArray(liveData.activeInternalSquads) ? liveData.activeInternalSquads : [];
                    const names = squads
                      .map((s) => {
                        if (typeof s === 'string') return s;
                        if (s && typeof s === 'object') return s.name || s.uuid || '';
                        return '';
                      })
                      .filter(Boolean);
                    if (names.length === 0) {
                      squadName = "Нет";
                    } else if (names.length === 1) {
                      squadName = names[0];
                    } else {
                      squadName = `${names[0]} +${names.length - 1}`;
                    }
                  }
                  const userBalance = user.balance !== undefined && user.balance !== null ? parseFloat(user.balance) : 0;
                  const currency = user.preferred_currency || 'uah';
                  const currencySymbol = currency === 'uah' ? '₴' : currency === 'rub' ? '₽' : '$';
                  
                  return (
                    <tr key={user.id} className="users-table-row">
                      <td data-label="ID" style={{ fontWeight: '600', color: 'var(--text-primary)' }}>{user.id}</td>
                      <td data-label="Email" title={user.email} style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {user.email || <span style={{ color: 'var(--text-secondary)', fontStyle: 'italic' }}>Нет email</span>}
                      </td>
                      <td data-label="Telegram" style={{ minWidth: '150px' }}>
                        {user.telegram_username ? (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <span style={{ fontWeight: '500', color: 'var(--text-primary)' }}>
                              @{user.telegram_username}
                            </span>
                            {user.telegram_id && (
                              <span style={{ fontSize: '11px', color: 'var(--text-secondary)', fontFamily: 'monospace' }}>
                                ID: {user.telegram_id}
                              </span>
                            )}
                          </div>
                        ) : user.telegram_id ? (
                          <span style={{ fontSize: '12px', color: 'var(--text-secondary)', fontFamily: 'monospace' }}>
                            ID: {user.telegram_id}
                          </span>
                        ) : (
                          <span style={{ color: 'var(--text-secondary)', fontStyle: 'italic', fontSize: '12px' }}>Нет</span>
                        )}
                      </td>
                      <td data-label="Role"><span className={`role-badge role-${user.role}`}>{user.role}</span></td>
                      <td data-label="Баланс" style={{ fontWeight: 'bold', color: userBalance > 0 ? '#10b981' : '#6b7280' }}>
                        {userBalance.toFixed(2)} {currencySymbol}
                      </td>
                      <td data-label="Статус"><span className={`status-badge status-${statusKey}`}>{statusLabel}</span></td>
                      <td data-label="Сквад">{squadName}</td>
                      <td data-label="Подписка до" className={expireAt.isExpired ? 'expired-cell' : ''}>{expireAt.text}</td>
                      <td data-label="Реф. Код" className="code-cell" style={{ fontFamily: 'monospace', fontSize: '12px', textAlign: 'center', verticalAlign: 'middle' }}>
                        {user.referral_code || <span style={{ color: 'var(--text-secondary)', fontStyle: 'italic' }}>N/A</span>}
                      </td>
                      <td data-label="Приглашен">
                        {user.referrer_id ? (
                          <span style={{ color: 'var(--text-primary)', fontWeight: '500' }}>#{user.referrer_id}</span>
                        ) : (
                          <span style={{ color: 'var(--text-secondary)', fontStyle: 'italic' }}>N/A</span>
                        )}
                      </td>
                      <td data-label="Действия" className="users-table-actions-cell">
                        {user.is_blocked && (
                          <span style={{ 
                            display: 'inline-block', 
                            padding: '4px 8px', 
                            backgroundColor: '#ef4444', 
                            color: 'white', 
                            borderRadius: '4px', 
                            fontSize: '11px',
                            marginBottom: '4px'
                          }}>
                            🚫 Заблокирован
                          </span>
                        )}
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                          <button
                            type="button"
                            className="btn-table-icon"
                            onClick={() => handleOpenBalanceModal(user)}
                            title="Баланс"
                            aria-label="Баланс"
                          >
                            <LuWallet />
                          </button>

                          <button
                            type="button"
                            className="btn-table-icon"
                            onClick={() => handleOpenEditModal(user)}
                            title="Редактировать"
                            aria-label="Редактировать"
                          >
                            <LuPencil />
                          </button>

                          {user.is_blocked ? (
                            <button
                              type="button"
                              className="btn-table-icon"
                              onClick={() => handleUnblockUser(user.id, user.email)}
                              title="Разблокировать"
                              aria-label="Разблокировать"
                            >
                              <LuShieldCheck />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn-table-icon danger"
                              onClick={() => handleOpenBlockModal(user)}
                              title="Заблокировать"
                              aria-label="Заблокировать"
                            >
                              <LuBan />
                            </button>
                          )}

                          <button
                            type="button"
                            className="btn-table-icon danger"
                            onClick={() => handleDeleteUser(user.id, user.email)}
                            title="Удалить"
                            aria-label="Удалить"
                          >
                            <LuTrash2 />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </section>

      {/* Модальное окно управления балансом */}
      {balanceModal.open && balanceModal.user && (
        <div 
          className="modal-overlay" 
          onClick={handleCloseBalanceModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
        >
          <div 
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '24px',
              maxWidth: '500px',
              width: '90%',
              maxHeight: '90vh',
              overflow: 'auto',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)'
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: '20px' }}>
              Управление балансом пользователя
            </h3>
            
            <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f3f4f6', borderRadius: '6px' }}>
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>Пользователь:</div>
              <div style={{ fontWeight: 'bold' }}>{balanceModal.user.email}</div>
              <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '8px' }}>
                Текущий баланс: <strong style={{ color: '#10b981' }}>
                  {(balanceModal.user.balance || 0).toFixed(2)} {(() => {
                    const currency = balanceModal.user.preferred_currency || 'uah';
                    return currency === 'uah' ? '₴' : currency === 'rub' ? '₽' : '$';
                  })()}
                </strong>
              </div>
            </div>

            <form onSubmit={handleUpdateBalance}>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Действие:
                </label>
                <select
                  value={balanceForm.action}
                  onChange={(e) => setBalanceForm({ ...balanceForm, action: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    fontSize: '14px'
                  }}
                >
                  <option value="add">Добавить к балансу</option>
                  <option value="subtract">Списать с баланса</option>
                  <option value="set">Установить баланс</option>
                </select>
              </div>

              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Сумма:
                </label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={balanceForm.amount}
                  onChange={(e) => setBalanceForm({ ...balanceForm, amount: e.target.value })}
                  placeholder="Введите сумму"
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    fontSize: '14px'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Описание (необязательно):
                </label>
                <textarea
                  value={balanceForm.description}
                  onChange={(e) => setBalanceForm({ ...balanceForm, description: e.target.value })}
                  placeholder="Причина изменения баланса"
                  rows="3"
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    fontSize: '14px',
                    resize: 'vertical'
                  }}
                />
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  onClick={handleCloseBalanceModal}
                  disabled={balanceLoading}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    backgroundColor: 'white',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Отмена
                </button>
                <button
                  type="submit"
                  disabled={balanceLoading}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '6px',
                    border: 'none',
                    backgroundColor: '#3b82f6',
                    color: 'white',
                    cursor: balanceLoading ? 'not-allowed' : 'pointer',
                    fontSize: '14px',
                    opacity: balanceLoading ? 0.6 : 1
                  }}
                >
                  {balanceLoading ? 'Обработка...' : 'Применить'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Модальное окно редактирования пользователя */}
      {editModal.open && editModal.user && (
        <div 
          className="modal-overlay" 
          onClick={handleCloseEditModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
        >
          <div 
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '24px',
              maxWidth: '500px',
              width: '90%',
              maxHeight: '90vh',
              overflow: 'auto',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)'
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: '20px' }}>
              Редактирование пользователя
            </h3>
            
            <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f3f4f6', borderRadius: '6px' }}>
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>Пользователь:</div>
              <div style={{ fontWeight: 'bold' }}>{editModal.user.email}</div>
            </div>

            {/* Табы */}
            <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', borderBottom: '1px solid #e5e7eb' }}>
              <button
                type="button"
                onClick={() => setEditModal({ ...editModal, activeTab: 'password' })}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  background: editModal.activeTab === 'password' ? '#3b82f6' : 'transparent',
                  color: editModal.activeTab === 'password' ? 'white' : '#6b7280',
                  cursor: 'pointer',
                  borderBottom: editModal.activeTab === 'password' ? '2px solid #3b82f6' : '2px solid transparent',
                  marginBottom: '-1px'
                }}
              >
                🔑 Пароль
              </button>
              <button
                type="button"
                onClick={() => setEditModal({ ...editModal, activeTab: 'subscription' })}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  background: editModal.activeTab === 'subscription' ? '#3b82f6' : 'transparent',
                  color: editModal.activeTab === 'subscription' ? 'white' : '#6b7280',
                  cursor: 'pointer',
                  borderBottom: editModal.activeTab === 'subscription' ? '2px solid #3b82f6' : '2px solid transparent',
                  marginBottom: '-1px'
                }}
              >
                📦 Подписка
              </button>
              <button
                type="button"
                onClick={() => setEditModal({ ...editModal, activeTab: 'referral' })}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  background: editModal.activeTab === 'referral' ? '#3b82f6' : 'transparent',
                  color: editModal.activeTab === 'referral' ? 'white' : '#6b7280',
                  cursor: 'pointer',
                  borderBottom: editModal.activeTab === 'referral' ? '2px solid #3b82f6' : '2px solid transparent',
                  marginBottom: '-1px'
                }}
              >
                💰 Реферал
              </button>
            </div>

            {/* Вкладка изменения пароля */}
            {editModal.activeTab === 'password' && (
              <form onSubmit={handleChangePassword}>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Новый пароль:
                </label>
                <input
                  type="password"
                  value={passwordForm.new_password}
                  onChange={(e) => setPasswordForm({ ...passwordForm, new_password: e.target.value })}
                  placeholder="Введите новый пароль (минимум 6 символов)"
                  required
                  minLength={6}
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    fontSize: '14px'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Подтвердите пароль:
                </label>
                <input
                  type="password"
                  value={passwordForm.confirm_password}
                  onChange={(e) => setPasswordForm({ ...passwordForm, confirm_password: e.target.value })}
                  placeholder="Повторите новый пароль"
                  required
                  minLength={6}
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    fontSize: '14px'
                  }}
                />
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  onClick={handleCloseEditModal}
                  disabled={passwordLoading}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    backgroundColor: 'white',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Отмена
                </button>
                <button
                  type="submit"
                  disabled={passwordLoading}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '6px',
                    border: 'none',
                    backgroundColor: '#10b981',
                    color: 'white',
                    cursor: passwordLoading ? 'not-allowed' : 'pointer',
                    fontSize: '14px',
                    opacity: passwordLoading ? 0.6 : 1
                  }}
                >
                  {passwordLoading ? 'Обработка...' : 'Изменить пароль'}
                </button>
              </div>
            </form>
            )}

            {/* Вкладка подписки */}
            {editModal.activeTab === 'subscription' && (
              <form onSubmit={handleUpdateUser}>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Выдать тариф:
                  </label>
                  <select
                    value={userForm.tariff_id}
                    onChange={(e) => setUserForm({ ...userForm, tariff_id: e.target.value, trial_days: '' })}
                    disabled={tariffsLoading || userFormLoading}
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '6px',
                      border: '1px solid #d1d5db',
                      fontSize: '14px'
                    }}
                  >
                    <option value="">Не выбран</option>
                    {tariffs.map(tariff => (
                      <option key={tariff.id} value={tariff.id}>
                        {tariff.name} ({tariff.duration_days} дней)
                      </option>
                    ))}
                  </select>
                  <small style={{ color: '#6b7280', fontSize: '12px' }}>
                    Выберите тариф для выдачи пользователю
                  </small>
                </div>

                <div style={{ marginBottom: '16px', textAlign: 'center', color: '#6b7280' }}>
                  <span>или</span>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Добавить триал (дней):
                  </label>
                  <input
                    type="number"
                    value={userForm.trial_days}
                    onChange={(e) => setUserForm({ ...userForm, trial_days: e.target.value, tariff_id: '' })}
                    placeholder="Количество дней триала"
                    min="1"
                    disabled={userFormLoading}
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '6px',
                      border: '1px solid #d1d5db',
                      fontSize: '14px'
                    }}
                  />
                  <small style={{ color: '#6b7280', fontSize: '12px' }}>
                    Укажите количество дней для триальной подписки
                  </small>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Лимит устройств:
                  </label>
                  <input
                    type="number"
                    value={userForm.hwid_device_limit}
                    onChange={(e) => setUserForm({ ...userForm, hwid_device_limit: e.target.value })}
                    placeholder="0 = безлимит"
                    min="0"
                    disabled={userFormLoading}
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '6px',
                      border: '1px solid #d1d5db',
                      fontSize: '14px'
                    }}
                  />
                  <small style={{ color: '#6b7280', fontSize: '12px' }}>
                    Максимальное количество устройств. 0 = безлимит
                  </small>
                </div>

                <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                  <button
                    type="button"
                    onClick={handleCloseEditModal}
                    disabled={userFormLoading}
                    style={{
                      padding: '10px 20px',
                      borderRadius: '6px',
                      border: '1px solid #d1d5db',
                      backgroundColor: 'white',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }}
                  >
                    Отмена
                  </button>
                  <button
                    type="submit"
                    disabled={userFormLoading}
                    style={{
                      padding: '10px 20px',
                      borderRadius: '6px',
                      border: 'none',
                      backgroundColor: '#3b82f6',
                      color: 'white',
                      cursor: userFormLoading ? 'not-allowed' : 'pointer',
                      fontSize: '14px',
                      opacity: userFormLoading ? 0.6 : 1
                    }}
                  >
                    {userFormLoading ? 'Обработка...' : 'Применить'}
                  </button>
                </div>
              </form>
            )}

            {/* Вкладка реферала */}
            {editModal.activeTab === 'referral' && (
              <form onSubmit={handleUpdateReferralPercent}>
                <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f0f9ff', borderRadius: '6px', border: '1px solid #bae6fd' }}>
                  <div style={{ fontSize: '13px', color: '#0369a1', marginBottom: '8px', fontWeight: '600' }}>
                    ℹ️ Информация о реферальной системе
                  </div>
                  <div style={{ fontSize: '12px', color: '#075985', lineHeight: '1.5' }}>
                    Процент реферала определяет, сколько процентов с покупок и пополнений баланса рефералов будет начисляться на баланс этого пользователя. 
                    Работает только при включенной системе "Проценты" в настройках рефералов.
                  </div>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Процент реферала (%):
                  </label>
                  <input
                    type="number"
                    value={referralForm.referral_percent}
                    onChange={(e) => setReferralForm({ referral_percent: e.target.value })}
                    placeholder="(пусто = по умолчанию)"
                    min="0"
                    max="100"
                    step="0.1"
                    disabled={referralLoading}
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '6px',
                      border: '1px solid #d1d5db',
                      fontSize: '14px'
                    }}
                  />
                  <small style={{ color: '#6b7280', fontSize: '12px' }}>
                    Укажите процент от 0 до 100. Если поле пустое — будет использоваться процент по умолчанию из настроек рефералов (и он будет меняться динамически).
                  </small>
                </div>

                <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                  <button
                    type="button"
                    onClick={handleCloseEditModal}
                    disabled={referralLoading}
                    style={{
                      padding: '10px 20px',
                      borderRadius: '6px',
                      border: '1px solid #d1d5db',
                      backgroundColor: 'white',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }}
                  >
                    Отмена
                  </button>
                  <button
                    type="submit"
                    disabled={referralLoading}
                    style={{
                      padding: '10px 20px',
                      borderRadius: '6px',
                      border: 'none',
                      backgroundColor: '#3b82f6',
                      color: 'white',
                      cursor: referralLoading ? 'not-allowed' : 'pointer',
                      fontSize: '14px',
                      opacity: referralLoading ? 0.6 : 1
                    }}
                  >
                    {referralLoading ? 'Обработка...' : 'Сохранить'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Модальное окно блокировки пользователя */}
      {blockModal.open && blockModal.user && (
        <div 
          className="modal-overlay" 
          onClick={handleCloseBlockModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
        >
          <div 
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: 'white',
              padding: '24px',
              borderRadius: '12px',
              maxWidth: '500px',
              width: '90%',
              maxHeight: '90vh',
              overflowY: 'auto'
            }}
          >
            <h2 style={{ marginTop: 0, marginBottom: '20px' }}>
              🚫 Заблокировать пользователя
            </h2>
            
            <p style={{ marginBottom: '16px', color: '#6b7280' }}>
              Пользователь: <strong>{blockModal.user.email}</strong>
            </p>

            <form onSubmit={handleBlockUser}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  Причина блокировки:
                </label>
                <textarea
                  value={blockReason}
                  onChange={(e) => setBlockReason(e.target.value)}
                  placeholder="Укажите причину блокировки аккаунта"
                  rows={4}
                  disabled={blockLoading}
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                />
                <small style={{ color: '#6b7280', fontSize: '12px' }}>
                  Эта причина будет показана пользователю при попытке входа
                </small>
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  onClick={handleCloseBlockModal}
                  disabled={blockLoading}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    backgroundColor: 'white',
                    color: '#374151',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Отмена
                </button>
                <button
                  type="submit"
                  disabled={blockLoading || !blockReason.trim()}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '6px',
                    border: 'none',
                    backgroundColor: '#ef4444',
                    color: 'white',
                    cursor: blockLoading || !blockReason.trim() ? 'not-allowed' : 'pointer',
                    fontSize: '14px',
                    opacity: blockLoading || !blockReason.trim() ? 0.6 : 1
                  }}
                >
                  {blockLoading ? 'Блокировка...' : 'Заблокировать'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </main>
  );
}

export default AdminUsersPage;